import React, { useEffect } from "react";
import Button from "./Button";
import BankSelectCon from '$Deposits/Components/Components/BankSelect'
import { bankCodeWriting } from '$Deposits/lib/LibCommonData'
import { connect } from "react-redux";
import Select, { Option } from "rc-select";

class BankSelect extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };

    }

    componentDidUpdate(prevProps, prevState) {

    }
    componentDidMount() {

    }
    componentWillUnmount() {

    }


    render() {

        const {isSearchable, MethodsActive} = this.props;

        return (
            <>
                <BankSelectCon
                    BankSelect={(propCon) => {
                        const {
                            BankList,
                            DepositBankActive,
                            onChange,
                            onChangeSearch,
                            searchValue,
                            LivechatClick,
                            isSearchable,
                            isAutoAssign,
                        } = propCon
                        return (
                            <>
                                {/*  普通银行选择 */}
                                <BankDrawer
                                    BankList={BankList}
                                    MethodsActive={MethodsActive}
                                    DepositBankActive={DepositBankActive}
                                    onChange={onChange}
                                    onChangeSearch={onChangeSearch}
                                    searchValue={searchValue}
                                    LivechatClick={LivechatClick}
                                    isSearchable={isSearchable}
                                    isAutoAssign={isAutoAssign}
                                />
                            </>
                        )
                    }}
                    CHANNEL={(propCon) => {
                        const {
                            BankList,
                            DepositBankActive,
                            onChange,
                        } = propCon
                        const { code } = DepositBankActive
                        return (
                            <>
                                <p className="inputTitle">เลือกสกุลเงินดิจิตอล</p>
                                <div className="CTCList">
                                    {
                                        BankList.map((item, index) => {
                                            return (
                                                <div
                                                    key={index}
                                                    className={`CTCListItem ${item.code == code ? 'CTCListItemActive' : ""}`}
                                                    onClick={() => { onChange(item) }}
                                                >
                                                    <div className={item.code + 'Icon'} />
                                                    <p>
                                                        <p>{`Tether USD`}</p>
                                                        <p>{`(${item.code})`}</p>
                                                    </p>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </>
                        )
                    }}

                />

            </>
        );
    }
}

const mapStateToProps = state => ({
    MethodsActive: state.MethodsActive,
});
const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(BankSelect)

export class BankDrawer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            bankModal: false,
            activeBank: '',
        };

    }

    componentDidUpdate(prevProps, prevState){
        if(prevState.bankModal !== this.state.bankModal && this.state.bankModal){
            this.setState({activeBank:""})
        }
    }
    render() {

        const { bankModal, activeBank } = this.state
        const {
            BankList,
            DepositBankActive,
            onChange,
            onChangeSearch,
            searchValue,
            LivechatClick,
            isSearchable,
            MethodsActive,
            isAutoAssign,
        } = this.props

        const { name, bankName, bankId, enBankName, englishName } = activeBank || DepositBankActive || {}
        return (
            <>
                <p className="inputTitle" data-CN="Fun88 Bank">{MethodsActive.code === "LB" ? "ธนาคาร FUN88" : "ธนาคาร"}</p>
                {BankList.length > 0 && <div className="drop-area fun88">
                    <Select
                        // open
                        showSearch={isSearchable}
                        size="large"
                        value={bankId}
                        optionLabelProp="children"
                        onChange={(v) => {
                            console.log('v TEST',v)
                            // 使用 value 在 BankList 中查找完整的选项对象
                            const selectedBank = BankList.find(bank => bank.bankId === v);
                            console.log('Selected bank object: ', selectedBank);
                            // 确保找到对象后再执行你的 onChange 函数
                            if (selectedBank && BankList.length > 0) {
                                onChange(selectedBank); // 这里传递的是找到的对象，而不仅仅是 bankId
                                onChangeSearch('');
                            }
                        }}
                        getPopupContainer={() =>
                            document.querySelector(".drop-area.fun88")
                        }
                        suffixIcon={
                            <span className="drawerIcon" />
                        }
                        // disabled={BankList.length == 1}
                    >
                        {BankList.map((value, index) => {
                            console.log(value)
                            return (
                                <Option
                                    value={value.bankId}
                                    key={index}
                                >
                                    <span className={'bankIcon-default bankIcon-' + bankCodeWriting(value.enBankName || value.englishName)} />
                                    <span>{value.bankName || value.name || 'ติดต่อฝ่ายบริการลูกค้า'}</span>
                                </Option>
                            );
                        })}
                    </Select>
                </div>}
                {
                    (isAutoAssign || BankList.length == 0) &&
                    <div onClick={LivechatClick} className="bank-liveChatBtn" disabled data-CN="目前無可收款存款銀行，請聯絡客服">
                        ขออภัยขณะนี้ไม่มีธนาคารเปิดใช้งานกรุณาติดต่อฝ่ายบริการ
                    </div>
                }
            </>
        )
    }
}


